import React, {useEffect, useState} from "react";
import {Alert, Button, Card, Col, Container, Form, Row, Table} from "react-bootstrap";
import ErrorToast from "../common/ErrorToast";
import Upload from "../../components/Upload";
import {useDispatch, useSelector} from "react-redux";
import "react-bootstrap-typeahead/css/Typeahead.css";
import {addDocument, changeClient, getDocuments, removeDocument} from "../../actions/admin/gapDocumentationActions";
import Modals from "../../components/modals";
import {useAuth} from "../../context/authContext";
import {getDisplayValue} from "../../utils/util";
import {stateFullName} from "../../utils/textValueLists";

const componentName="GapDocumentation";

export const GapDocumentation = () => {
  const isEmpty = require("is-empty");
  const dispatch = useDispatch();
  const { uploads, history } = useSelector((state) => state.gapDocumentation);
  const errors = useSelector((state) => state.errors);
  const [showModal, setShowModal] = useState(false);
  const [selectedDoc, setselectedDoc] = useState();
  const [file, setFile] = useState();
  const [fileName, setFileName] = useState();
  const [documentDisplayName, setDocumentDisplayName] = useState("");
  const [disableInput, setDisableInput] = useState(true);
  const [selectedClient, setSelectedClient] = useState();
  const [showAlert, setShowAlert] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const auth = useAuth();
  const inputSources = auth.getInputSources().sort();

  useEffect(() => {
    if (inputSources.length > 0) {
      setSelectedClient(inputSources[0]);
      setDisableInput(false);
      (async function fetchData() {
        await dispatch(changeClient());
        await dispatch(getDocuments(inputSources[0]));
      })();
    }
  }, [dispatch, inputSources]);

  const setFileMethod = (file) => {
    if (file && file.name) {
      setFileName(file.name)
    }
    const fileReader = new FileReader();
    if (fileReader && file) {
      fileReader.readAsArrayBuffer(file);
      fileReader.onload = function () {
        setFile(fileReader.result)
      };
    }
  };

  const handleChangeWithinModal = async (e) => {
    const obj = e.target.value;
    await dispatch(changeClient());
    if (obj) {
      setDisableInput(false);
      setSelectedClient(obj);
      await dispatch(getDocuments(obj));
    } else {
      setDisableInput(true);
    }
  };

  const handleNameChange = (e) => {
    const { value } = e.target;
    if(typeof value === "undefined") {
      setDocumentDisplayName("");
    } else {
      setDocumentDisplayName(value);
    }
  }

  const setDocumentToRemove = document => {
    setselectedDoc(document);
    setShowModal(true);
  }

  const removeSetDocument = () => {
    dispatch(removeDocument(selectedDoc));
    setShowModal(false);
  }

  const submitDocument = async () => {
    const result = await dispatch(addDocument(file, encodeURIComponent(selectedClient), fileName, encodeURIComponent(documentDisplayName)));
    if (result && result.status && result.status === 500) {
      setSubmitError("Unable to add more documents. Please remove one or more documents.");
      setShowAlert(true);
    }
    await dispatch(getDocuments(selectedClient));
  }

  return (
    <Container fluid>
      <Row className="py-3">
        <Col>
          {showAlert && (
            <Alert id={`${componentName}-alertMessage`} variant="danger" onClose={() => setShowAlert(false)} dismissible>
              {submitError}
            </Alert>)
          }
          {errors && errors.message && <ErrorToast />}
          <Card>
            <Card.Body>
              <Row className="align-items-end">
                <Col className="mb-3">
                  <Form.Label>
                    <span id={`${componentName}-clientLabel`}>Client</span>
                  </Form.Label>
                  <Form.Control
                      as="select"
                      name="client"
                      value={selectedClient}
                      id={`${componentName}-clientValue`}
                      className="form-select"
                      onChange={(e) => handleChangeWithinModal(e)}
                  >
                    {inputSources.map((r, idx) => (
                        <option id={`${componentName}-clientsItems-${idx}`} key={r} value={r}>
                          {getDisplayValue(stateFullName, r)}
                        </option>
                    ))}
                  </Form.Control>
                </Col>
                <Col className="mb-3">
                  <Upload
                    fileName={fileName}
                    setFile={setFileMethod}
                    disabled={disableInput}
                    accept="application/pdf"
                  />
                </Col>
                <Col className="mb-3">
                  <input
                      type="text"
                      className="form-control"
                      name="documentDisplayName"
                      id={`${componentName}-addDocumentNameValue`}
                      placeholder={"Document Name"}
                      onChange={(e) => handleNameChange(e)}
                  />
                </Col>
              </Row>
              <Button
                id={`${componentName}-addDocumentButton`}
                variant="primary"
                className="mb-3"
                disabled={disableInput || isEmpty(file)}
                onClick={() => submitDocument()}
              >
                Add Document
              </Button>

              <div className="mb-3">
                {uploads && uploads.length ? (
                  <Table responsive borderless>
                    <thead>
                      <tr>
                        <th id={`${componentName}-documentNameLabel`}>Document Name</th>
                        <th id={`${componentName}-uploadedByLabel`}>Uploaded By</th>
                        <th id={`${componentName}-uploadedDateLabel`}>Uploaded Date</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {uploads.map((upload, idx) => {
                        return (
                          <tr key={upload.gapDocumentationId ?? `${upload.displayName}-${idx}`}>
                            <td id={`${componentName}-documentNameValue-${idx}`}>{upload.displayName}</td>
                            <td id={`${componentName}-uploadedByValue-${idx}`}>{upload.uploadedByUser}</td>
                            <td id={`${componentName}-documentName-${idx}`}>{upload.uploadedDate}</td>
                            <Button id={`${componentName}-removeDocumentButton-${idx}`} variant="danger" onClick={() => setDocumentToRemove(upload)}>
                              REMOVE
                            </Button>
                          </tr>
                        )
                      })}
                    </tbody>
                  </Table>
                ) : null}
              </div>

              <Modals
                show={showModal}
                onHide={() => setShowModal(false)}
                title="Remove Document"
                size="md"
                completeBtn={"OK"}
                onCreate={removeSetDocument}
                body="Are you sure you want to remove this document?"
              />

              <Form.Label>
                <span id={`${componentName}-historyLabel`}>History</span>
              </Form.Label>

              <Table responsive striped bordered hover>
                <thead>
                  <tr>
                    <th id={`${componentName}-historyDocumentNameLabel`}>Document Name</th>
                    <th id={`${componentName}-historyUploadedByLabel`}>Uploaded By</th>
                    <th id={`${componentName}-historyUploadedDateLabel`}>Uploaded Date</th>
                    <th id={`${componentName}-historyRemovedByLabel`}>Removed By</th>
                    <th id={`${componentName}-historyRemovedDateLabel`}>Remove Date</th>
                  </tr>
                </thead>
                <tbody>
                  {history && history.length ? (
                    history.map((doc, idx) => {
                      return (
                        <tr key={doc.gapDocumentationId ?? `${doc.displayName}-${idx}`}>
                          <td id={`${componentName}-historyDocumentNameValue-${idx}`}>{doc.displayName}</td>
                          <td id={`${componentName}-historyUploadedByValue-${idx}`}>{doc.uploadedByUser}</td>
                          <td id={`${componentName}-historyUploadedDateValue-${idx}`}>{doc.uploadedDate}</td>
                          <td id={`${componentName}-historyRemovedByValue-${idx}`}>{doc.removedByUser}</td>
                          <td id={`${componentName}-historyRemovedDateValue-${idx}`}>{doc.removedDate}</td>
                        </tr>
                      )
                    })
                  ) : null}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default GapDocumentation;
